import { logWarn } from "@/lib/structured-log";
import { createServerFn } from "@tanstack/react-start";

export interface SentryConfigPayload {
  sentryDSN: string;
  sentryEnvironment: string;
}

function resolveSentryEnvironment(): string {
  const appEnv = process.env.APP_ENV?.trim();
  if (appEnv && appEnv.length > 0) {
    return appEnv;
  }

  return process.env.NODE_ENV || "development";
}

function shouldDisableSentry(environment: string): boolean {
  const normalizedEnvironment = environment.trim().toLowerCase();
  return normalizedEnvironment === "development";
}

export const getSentryConfigServer = createServerFn({ method: "GET" }).handler(
  async (): Promise<SentryConfigPayload> => {
    // Server-side environment variables (no VITE_ prefix needed)
    // These can be set at runtime in Docker container
    const configuredSentryDSN = process.env.SENTRY_DSN || import.meta.env.SENTRY_DSN || "";

    // APP_ENV distinguishes dev/staging/prod deployments more accurately than NODE_ENV,
    // which is often fixed to "production" in built frontend containers.
    const sentryEnvironment = resolveSentryEnvironment();
    const sentryDSN = shouldDisableSentry(sentryEnvironment) ? "" : configuredSentryDSN;

    if (!configuredSentryDSN) {
      logWarn(
        "[Sentry Config] SENTRY_DSN not found in environment variables. " +
          "Make sure it's set in .env file (dev) or Docker/K8s env (prod).",
      );
    }

    if (configuredSentryDSN && !sentryDSN) {
      logWarn(`Sentry disabled for environment: ${sentryEnvironment}`);
    }

    return { sentryDSN, sentryEnvironment };
  },
);
